const mockConfig = {
  player: {
    "6022359826810851": {
      id: "6022359826810851",
      name: "Foxy Fox",
      photo: "https://storage.googleapis.com/devkit-instant/avatar/animal_0002.png",
      haveContext: true
    },
    "2514324314253407": {
      id: "2514324314253407",
      name: "Squidy Squid",
      photo: "https://storage.googleapis.com/devkit-instant/avatar/animal_0003.png",
      haveContext: true
    },
    "1986709586798753": {
      id: "1986709586798753",
      name: "うさぎ-ちゃん",
      photo: "https://storage.googleapis.com/devkit-instant/avatar/animal_0004.png",
      haveContext: true
    },
    "6879178275649305": {
      id: "6879178275649305",
      name: "Pedro Parrot",
      photo: "https://storage.googleapis.com/devkit-instant/avatar/animal_0005.png",
      haveContext: true
    },
    "5358425046345768": {
      id: "5358425046345768",
      name: "Froggy Frog",
      photo: "https://storage.googleapis.com/devkit-instant/avatar/animal_0006.png",
      haveContext: false
    },
    "1156382005235567": {
      id: "1156382005235567",
      name: "Teddy Bear",
      photo: "https://storage.googleapis.com/devkit-instant/avatar/animal_0007.png",
      haveContext: false
    },
    "6883023789966730": {
      id: "6883023789966730",
      name: "竹熊猫",
      photo: "https://storage.googleapis.com/devkit-instant/avatar/animal_0008.png",
      haveContext: false
    },
    "4455676893732006": {
      id: "4455676893732006",
      name: "Doge",
      photo: "https://storage.googleapis.com/devkit-instant/avatar/animal_0009.png",
      haveContext: false
    }
  },
  group: {
    "0000006279834560": {
      name: "group 1",
      players: ["6022359826810851", "2514324314253407", "1156382005235567"]
    },
    "0000006928932494": {
      name: "group 2",
      players: ["1156382005235567", "5358425046345768"]
    },
    "0000006062502756": {
      name: "group 3",
      players: [
        "2514324314253407",
        "5358425046345768",
        "6883023789966730",
        "4455676893732006"
      ]
    }
  },
  tournament: {
    "11111111111": {
      name: "tournament 1",
      players: []
    },
    "22222222222": {
      name: "tournament 2",
      players: []
    },
    "33333333333": {
      name: "tournament 3",
      players: []
    }
  },
  squad: {
    "59111111111": {
      name: "squad 1",
      players: ["6022359826810851", "2514324314253407", "1156382005235567"]
    },
    "59222222222": {
      name: "squad 2",
      players: ["1156382005235567", "5358425046345768"]
    },
    "59333333333": {
      name: "squad 3",
      players: [
        "2514324314253407",
        "5358425046345768",
        "6883023789966730",
        "4455676893732006"
      ]
    }
  }
};
export {
  mockConfig as default
};
